import { put, call } from 'redux-saga/effects'
import TicketActions from '../store/ticketRedux'

export function* queryTickets(api, action) {
    try {
        // make request using the query parameters given
        var response = yield call(api.queryTickets, action.queryParams);

        if (response.ok && response.status === 200) {
            // add returned data to the store.
            yield put(TicketActions.setTickets(action.queryKey, response.data))
        } else {
            // set to empty object to indicate that we're no longer loading
            yield put(TicketActions.setTickets(action.queryKey, {}))
        }
    } catch (ex) {
        console.log(ex)
        yield put(TicketActions.setTickets(action.queryKey, {}))
    }
}

export function* getTicket(api, action) {
    if(typeof action.ticketId !== 'number' ||isNaN(action.ticketId)) {
        yield put(TicketActions.setSelectedTicket(null));
    }
    try {
        var response = yield call(api.getTicket, action.ticketId);
        if (response.ok && response.status === 200) {
            yield put(TicketActions.setSelectedTicket(response.data));
        } else {
            // TODO - need some error handling here
            yield put(TicketActions.setSelectedTicket(null))
        }
    } catch (ex) {
        console.log(ex)
        yield put(TicketActions.setSelectedTicket(null))
    }
}

export function* getEligibleAddonProducts(api, action) {
    try {
        var response = yield call(api.getEligibleAddonProducts, action.ticketId);

        if (response.ok && response.status === 200) {
            yield put(TicketActions.setEligibleAddonProducts(response.data))
            }
    } catch (ex) {
        console.log(ex)
        yield put(TicketActions.setEligibleAddonProducts({}))
    }
}